var _defs, _path, _ellipse, _path2, _rect, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGasStation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#878787;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gas_station") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.05,0A16.06,16.06,0,0,0,0,15.92C0,26.83,14.34,42.85,14.94,43.55a1.46,1.46,0,0,0,2.11,0c.6-.7,15-16.72,15-27.63A15.79,15.79,0,0,0,16.05,0Zm0,24a8.13,8.13,0,0,1-8.13-8,8.13,8.13,0,1,1,8.13,8Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 16.05,
    cy: 15.82,
    rx: 12.04,
    ry: 12.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.66,8a.68.68,0,0,0-.7-.7H12a.69.69,0,0,0-.71.7V21.42h9.13C20.66,21,20.66,8.21,20.66,8Zm-.9,5.21a.47.47,0,0,1-.5.5H13a.47.47,0,0,1-.5-.5V9a.47.47,0,0,1,.5-.5h6a.47.47,0,0,1,.5.5l.2,4.21Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.54,
    y: 9.61,
    width: 5.02,
    height: 3.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.77,22.43H10.43a.47.47,0,0,0-.5.5v1.2a.22.22,0,0,0,.2.2H22.07a.22.22,0,0,0,.2-.2v-1.2A.47.47,0,0,0,21.77,22.43Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStation);
export default __webpack_public_path__ + "static/media/gas_station.0d29eff70304fd09c3717dc0955035d3.svg";
export { ForwardRef as ReactComponent };